var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9657 2.63422C15.2782 2.94664 15.2782 3.45317 14.9657 3.76559L6.16573 12.5656C5.85331 12.878 5.34678 12.878 5.03436 12.5656L1.03436 8.56559C0.721944 8.25317 0.721944 7.74664 1.03436 7.43422C1.34678 7.1218 1.85331 7.1218 2.16573 7.43422L5.60005 10.8685L13.8344 2.63422C14.1468 2.3218 14.6533 2.3218 14.9657 2.63422Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedCheckIcon);
export default __webpack_public_path__ + "static/media/selected_check_icon.f9a0f3f23eea0b58f179dc6c6a4412ca.svg";
export { ForwardRef as ReactComponent };